import { EnvironmentProviders, Provider } from '@angular/core';

import { NgIconsService } from './ng-icons.service';

/**
 * Provider dla ikon aplikacji używający @ng-icons
 * Zapewnia tree-shaking i wsparcie SSR
 */
export const provideIcons = (): (Provider | EnvironmentProviders)[] => {
  // Zwraca wszystkie providery z NgIconsService
  // Zawiera konfigurację i wszystkie używane ikony
  return NgIconsService.getProviders();
};
